import React, { useState, useEffect } from 'react'
import {
	FormGroup, TextInput, ComboBox, TextArea, Button, Link, Dropdown
} from 'carbon-components-react';
import IncidentDetailsHeaderPanel from './IncidentDetailsHeaderPanel';
import * as IncidentDetailsConstants from './IncidentDetailsConstants';
import IncidentDetailsTab from './IncidentDetailsTab';
import callPostApi from "../../../requests/PostRequests";
import callGetApi from '../../../requests/GetRequests';
import * as Constants from '../../../requests/URLConstants';
import * as IncidentDetailsUtil from '../IncidentDetailsUtil.js';
import * as SearchDropdown from 'utils/SearchDropdown';
import * as workspaces from '../../../config/WorkspaceConstants'
import * as configConst from "../../../config/Constants";

require("./_incidentDetailsPage.scss");

const IncidentDetailsFieldComponent = (props) => {
	const [showMoreFields, setShowMoreFields] = useState(false);
	const [incidentDetailsData, setIncidentDetailsData] = useState([]);
	const [assignedToList, setAssignedToList] = useState([]);
	const [assignmentGroupList, setAssignmentGroupList] = useState([]);
	const [categoryList, setCategoryList] = useState([]);
	const [subCategoryList, setSubCategoryList] = useState([]);
	const [somFieldToBeUpdated, setSomFieldToBeUpdated] = useState([]);
	const [showSomUpdateIncidentWarningModal, setShowSomUpdateIncidentWarningModal] = useState(false);
	const [stateList, setStateList] = useState([]);
	const [urgencyList, setUrgencyList] = useState([]);
	const [impactList, setImpactList] = useState([]);
	const [contactTypeList, setContactTypeList] = useState([]);
	const [resolvedBySOCList, setResolvedBySOCList] = useState([]);
	const [actionTakenBySOCList, setActionTakenBySOCList] = useState([]);
    const [PriorityList, setPriorityList] = useState([]);
    const [reasonsToUpgradeList, setReasonsToUpgradeList] = useState([]);
    const [reasonsToDowngradeList, setReasonsToDowngradeList] = useState([]);
    const [priorityBasedOnImpactandUrgency, setPriorityBasedOnImpactandUrgency] = useState({});
    const [UpgradeDowngrade, setUpgradeDowngrade] = useState('');
	const [showReasonsToUpgradeDowngrade, setShowReasonsToUpgradeDowngrade] = useState(false);
    const [upgradeDowngradeError, setUpgradeDowngradeError] = useState(false);
    const [assignedTo, setAssignedTo] = useState(false);

	// change for categoryId
	useEffect(() => {
		if (!props.incidentDetailsLoading && props.incidentDetailsData) {
			getSubCategoryList(props.incidentDetailsData.category.label);
		}
	}, [categoryList.length]);

	useEffect(() => {
		if (!props.incidentDetailsLoading && !props.incidentDetailsCustomFieldLoading && props.incidentDetailsData) {
			setIncidentDetailsData(props.incidentDetailsData);
			getCategoryList(props.incidentDetailsData.franchise);
			// change for categoryId
			// getSubCategoryList(props.incidentDetailsData.category.label);
			getAssignedToList(props.incidentDetailsData.assignment_group.label);
			getAssignmentGroupList();
			getIncidentStatusList();
			getIncidentUrgencyList();
			getIncidentImpactList();
			getIncidentContactTypeList();
			getResolvedBySOCList();
			getActionTakenBySOCList();
            getIncidentPriorityList();
            getReasonsToUpgradeDowngradeList();
		}
	}, [props.incidentDetailsLoading, props.incidentDetailsCustomFieldLoading]);

	const filterDropdown = (id) => {
		let input, filter, a, i, txtValue;
		let currentWorkingElement = [];
		input = document.getElementById(id);
		filter = input.value.toUpperCase();
		let div = document.getElementsByClassName("bx--list-box__wrapper");
		currentWorkingElement = Array.prototype.filter.call(
			div,
			function (el) { return el.getAttribute('aria-expanded') === 'true'; }
		);
		if (currentWorkingElement.length) {
			a = currentWorkingElement[0].getElementsByClassName("bx--list-box__menu-item");
			for (i = 0; i < a.length; i++) {
				txtValue = a[i].textContent || a[i].innerText;
				if (txtValue.toUpperCase().indexOf(filter) > -1) {
					a[i].style.display = "";
				} else {
					a[i].style.display = "none";
				}
			}
		}
	};

	const prepareDropdownData = (response, type) => {
		let list = [];
		let uniqueList = [];
		if (response && response.result) {
			for (var i = 0; i < response.result.length; i++) {
				if (type === 'assignedTo') {
					list.push({ 'label': response.result[i].user, 'id': i });
				} else if (type === 'assignmentGroup') {
					list.push({ 'label': response.result[i].name, 'id': i });
				} else if (type === 'category') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
				} else if (type === 'subcategory') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
				} else if (type === 'state') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
				} else if (type === 'urgency') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
				} else if (type === 'impact') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
				} else if (type === 'contactType') {
					list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                } else if (type === 'resolvedBySOC') {
                    list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                } else if (type === 'actionTakenBySOC') {
                    list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                } else if (type === 'reasonsToUpgrade') {
                    list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                } else if (type === 'reasonsToDowngrade') {
                    list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                } else if (type === 'priority') {
                    list.push({ 'label': response.result[i].label, 'id': response.result[i].value });
                }
			}
			uniqueList = [...new Map(list.map(item =>
				[item['label'], item])).values()];

		}
		return uniqueList;
	};

	const getIncidentStatusList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETINCIDENTSTATUSOPTIONS + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'state');
			setStateList(formattedData);
		});
	};

	const getIncidentUrgencyList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETINCIDENTURGENCYOPTIONS + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'urgency');
			setUrgencyList(formattedData);
		});
	};

	const getIncidentImpactList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETINCIDENTIMPACTOPTIONS + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'impact');
			setImpactList(formattedData);
		});
	};

	const getIncidentContactTypeList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETINCIDENTCONTACTTYPEOPTIONS + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'contactType');
			setContactTypeList(formattedData);
		});
	};

	const getAssignedToList = (param) => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);
		let bodyJSON = {
			'assignment_group': param,
			'workspace': workspaceToSend,
			'client': clientToSend
		}
		callPostApi(Constants.GETASSIGNEDTO, {
			'Content-Type': 'application/json'
		}, bodyJSON).then(response => {
			formattedData = prepareDropdownData(response, 'assignedTo');
			setAssignedToList(formattedData);
		});
	};

	const getAssignmentGroupList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETASSIGNMENTGROUP + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'assignmentGroup');
			setAssignmentGroupList(formattedData);
		});
	};

	const getCategoryList = (franchise) => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let bodyJSON = {
			'franchise': franchise,
			'workspace': workspaceToSend,
			'client': clientToSend
		};

		callPostApi(Constants.GETALLCATEGORYURL, {
			'Content-Type': 'application/json'
		}, bodyJSON).then(response => {
			formattedData = prepareDropdownData(response, 'category');
			setCategoryList(formattedData);
		});
	};

	// change for categoryId
	const getSelectedCategoryId = () => {
		if(categoryList.length && props.incidentDetailsData) {
			let category = categoryList.filter(function(category){ return category.label.toUpperCase() === props.incidentDetailsData.category.label.toUpperCase()});
			if(category[0]) {
				return category[0].id;
			} else {
				return null;
			}
		} else return null;
	};

	// change for categoryId
	// const getSubCategoryList = (category) => {
	const getSubCategoryList = (category, categoryId) => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);
		// change for categoryId
		let category_id = categoryId || getSelectedCategoryId();
		let bodyJSON = {
			'category': category,
			'workspace': workspaceToSend,
			'client': clientToSend,
			'category_id': category_id
		};
		callPostApi(Constants.GETALLSUBCATEGORYURL, {
			'Content-Type': 'application/json'
		}, bodyJSON).then(response => {
			formattedData = prepareDropdownData(response, 'subcategory');
			setSubCategoryList(formattedData);
		});
	};

	//DSO newly added fields(Custom_ops)
	const getResolvedBySOCList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETRESOLVEDBYSOC + '/' + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'resolvedBySOC');
			setResolvedBySOCList(formattedData);
		});
	};

	const getActionTakenBySOCList = () => {
		let formattedData = {};
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

		let url = Constants.GETACTIONTAKENBYSOC + '/' + clientToSend + '/' + workspaceToSend;

		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			formattedData = prepareDropdownData(response, 'actionTakenBySOC');
			setActionTakenBySOCList(formattedData);
		});
	};

    useEffect(() => {
        //check upgrade or downgrade based on current and previous priority values
        if (priorityBasedOnImpactandUrgency.value && PriorityList) {
            checkUpgradeDowngrade(priorityBasedOnImpactandUrgency.value);
        }
    }, [priorityBasedOnImpactandUrgency, PriorityList]);

    const getIncidentPriorityList = () => {
        let formattedData = {};
        let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
        let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);
        let url = Constants.GETINCIDENTPRIORITYOPTIONS + clientToSend + '/' + workspaceToSend;
        callGetApi(url, { 'Content-Type': 'application/json' }).then(response => {
            formattedData = prepareDropdownData(response, 'priority');
            setPriorityList(formattedData);
        }).catch(error => {
            setPriorityList([]);
        })
    };

    const getReasonsToUpgradeDowngradeList = () => {
        let formattedData = {};
        let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
        let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);
        let bodyJSON = {
            'workspace': workspaceToSend,
            'client': clientToSend
        };

        callPostApi(Constants.GETPRIORITYUPGRADEREASON, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response => {
            formattedData = prepareDropdownData(response, 'reasonsToUpgrade');
            setReasonsToUpgradeList(formattedData);
        }).catch(error => {
            setReasonsToUpgradeList([]);
        });

        callPostApi(Constants.GETPRIORITYDOWNGRADEREASON, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response => {
            formattedData = prepareDropdownData(response, 'reasonsToDowngrade');
            setReasonsToDowngradeList(formattedData);
        }).catch(error => {
            setReasonsToDowngradeList([]);
        });
    };

    const getPriorityBasedOnImpactAndUrgency = (data) => {
        //function to get updated priority based on impact and urgency selections
        let SelectedImpact = impactList && impactList.length > 0 ? impactList.filter(item => item.label === data.impact) : []
        let SelectedUrgency = urgencyList && urgencyList.length > 0 ? urgencyList.filter(item => item.label === data.urgency) : []
        let ImpactNumber = SelectedImpact.length > 0 ? parseInt(SelectedImpact[0].id) : '';
        let UrgencyNumber = SelectedUrgency.length > 0 ? parseInt(SelectedUrgency[0].id) : '';

        let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
        let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.incidentDetailsData.u_client);

        let bodyJSON = {
            'impact': ImpactNumber,
            'urgency': UrgencyNumber,
            'workspace': workspaceToSend,
            'client': clientToSend
        }
        //console.log(data, bodyJSON, "getPriority data")
        let url = Constants.GETPRIORITYBASEDONIMPACTANDURGENCY;
        callPostApi(url, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response => {
            if (response.result && response.result[0]) {
                setPriorityBasedOnImpactandUrgency(response.result[0]);
            }
            else setPriorityBasedOnImpactandUrgency({});
        }).catch((error) => {
            setPriorityBasedOnImpactandUrgency({});
        });
    };

    const checkUpgradeDowngrade = (priority) => {
        let priorityNumber = priority;
       //console.log(priorityNumber, "-priorityNumber,", PrevPriorityNumber, "-PrevPriorityNumber");
        let PrevPriority = PriorityList && PriorityList.length > 0 ? PriorityList.filter(item => item.label === incidentDetailsData.priority) : []
        let PrevPriorityNumber = PrevPriority.length > 0 ? PrevPriority[0].id : '';

        //compare previous and current priority and show dropdown label accordingly
        if (priorityNumber && PrevPriorityNumber) {
            if (priorityNumber < PrevPriorityNumber) {
                setUpgradeDowngrade("Upgrade");
                setShowReasonsToUpgradeDowngrade(true);
            }
            else if (priorityNumber > PrevPriorityNumber) {
                setUpgradeDowngrade("Downgrade");
                setShowReasonsToUpgradeDowngrade(true);
            }
            else {
                setUpgradeDowngrade('');
                setShowReasonsToUpgradeDowngrade(false);
            }
        }
        else {
            setUpgradeDowngrade('');
            setShowReasonsToUpgradeDowngrade(false);
        }
    };

	const toggleFieldsVisibility = () => {
		setShowMoreFields(!showMoreFields);
	};

	const updateDependentFields = (fieldName, value, id) => {
		let updatedData = incidentDetailsData;
		updatedData[fieldName] = { label: value, id: id };
		switch (fieldName) {
			case 'category':
				updatedData['subcategory'] = { 'label': '', 'id': '' };
				getSubCategoryList(value);
				break;
			case 'assignment_group':
				updatedData['assigned_to'] = { 'label': '', 'id': '' };
				getAssignedToList(value);
				break;
			default:
				break;
		}
		setIncidentDetailsData({ ...updatedData });
	};

    const changeIncidentDataValue = (e, fieldName) => {
        let value = e.selectedItem ? e.selectedItem.label : '';
        let id = e.selectedItem ? e.selectedItem.id : '';
        setIncidentDetailsData({ ...incidentDetailsData, [fieldName]: { 'label': value, 'id': id } });
        updateDependentFields(fieldName, value, id);
        let data = {};
        //assign impact and urgency, if no value is selected then current value will be assigned and if there is any change then the recent change will be assigned
        data.impact = incidentDetailsData.impact.label ? incidentDetailsData.impact.label : props.incidentDetailsDataForCompare.impact.label;
        data.urgency = incidentDetailsData.urgency.label ? incidentDetailsData.urgency.label : props.incidentDetailsDataForCompare.urgency.label;

        if (props.workspace === workspaces.custom_ops) {
            if (fieldName === "impact" || fieldName === "urgency") {
                //to get recent priority based on impact and urgency selections
                getPriorityBasedOnImpactAndUrgency(data);
            }
            if (fieldName === "assigned_to") {
                if (id !== '' && value !== '') {
                    setAssignedTo(false);
                }
                else {
                    setAssignedTo(true);
                }
            }
        }
    };

	const closeSomUpdateIncidentWarningModal = () => {
		setShowSomUpdateIncidentWarningModal(false);
	};

	const updateSomData = (name, value, id) => {
		let availableList = [];
		let valueToMatch = '';
		switch (name.type) {
			case 'category':
				availableList = categoryList;
				getSubCategoryList(value);
				valueToMatch = availableList.find(o => o.label === value.category);
				if (valueToMatch) {
					setShowSomUpdateIncidentWarningModal(false);
					setIncidentDetailsData({ ...incidentDetailsData, category: { 'label': value.category, 'id': value.category } , predicted_category: value.predicted_category});
				} else {
					setSomFieldToBeUpdated(name);
					setShowSomUpdateIncidentWarningModal(true);
				}
				break;
			case 'assignment_group':
				availableList = assignmentGroupList;
				getAssignedToList(value);
				valueToMatch = availableList.find(o => o.label === value.assignment_group);
				if (valueToMatch) {
					setShowSomUpdateIncidentWarningModal(false);
					setIncidentDetailsData({ ...incidentDetailsData, assignment_group: { 'label': value.assignment_group, 'id': value.assignment_group }, predicted_owner: value.predicted_owner });
				} else {
					setSomFieldToBeUpdated(name);
					setShowSomUpdateIncidentWarningModal(true);
				}
				break;
			default:
				if(value === 'A') {
					setIncidentDetailsData({ ...incidentDetailsData, [name]: value });
				} else {
					setIncidentDetailsData({ ...incidentDetailsData, ...name });
				}
				valueToMatch = '';
				break;
		}
	};

    const handleReasonDropdownError = (bool) => {
        setUpgradeDowngradeError(bool)
    };

    const statusChange = (status) => {
        setAssignedTo(status);
    }

	return (
		<>
            <IncidentDetailsHeaderPanel incidentDetailsData={incidentDetailsData} incidentDetailsDataForCompare={props.incidentDetailsDataForCompare}
                stateList={stateList} sysId={props.sysId} updateIncident={props.updateIncident} disableIncidentUpdate={props.disableIncidentUpdate}
                ticketingToolPath={incidentDetailsData.ticketingToolPath} workspace={props.workspace} handleReason={props.handleReason}
                UpgradeDowngrade={UpgradeDowngrade} handleReasonDropdownError={handleReasonDropdownError} statusChange={statusChange} assignedTo={assignedTo} />
			<div className="incident-details-fields-container">
				<div className="bx--grid">
					<div className="bx--row">
						<div className="bx--col bx--col-sm-4" >
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<TextInput id="caller" labelText={IncidentDetailsConstants.Caller} value={incidentDetailsData.caller_id} disabled />
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<Dropdown
										id="contact-type"
										label={IncidentDetailsConstants.Contacttype}
										titleText={IncidentDetailsConstants.Contacttype}
										items={contactTypeList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.contact_type}
										onChange={(e) => changeIncidentDataValue(e, 'contact_type')}
										disabled={props.disableIncidentUpdate}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<ComboBox
										ariaLabel="ComboBox"
										id="assignment-group"
										placeholder={IncidentDetailsConstants.SelectAssignmentgroup}
										titleText={IncidentDetailsConstants.AssignmentGroup}
										items={assignmentGroupList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.assignment_group}
										onChange={(e) => changeIncidentDataValue(e, 'assignment_group')}
										disabled={props.disableIncidentUpdate}
										onInputChange={() => SearchDropdown.filterDropdown("assignment-group")}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<ComboBox
										ariaLabel="ComboBox"
										id="assigned-to"
										className="assigned-to"
										placeholder={IncidentDetailsConstants.SelectAssignedto}
                                        titleText={props.workspace === workspaces.custom_ops ? `${IncidentDetailsConstants.AssignedTo}*` : IncidentDetailsConstants.AssignedTo}
										items={assignedToList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.assigned_to}
										disabled={props.disableIncidentUpdate}
										onInputChange={() => SearchDropdown.filterDropdown("assigned-to")}
										onChange={(e) => changeIncidentDataValue(e, 'assigned_to')}
                                        invalid={assignedTo === true && props.workspace === workspaces.custom_ops ? true : false}
                                        invalidText="Assigned To field should not be empty"
									/>
								</FormGroup>
							</div>
						</div>

					</div>
					<div className="bx--row">
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<TextInput id="franchise" labelText={IncidentDetailsConstants.franchise} value={incidentDetailsData.franchise} disabled />
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<Dropdown
										id="category"
										label={IncidentDetailsConstants.Category}
										titleText={IncidentDetailsConstants.Category}
										items={categoryList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.category}
										onChange={(e) => changeIncidentDataValue(e, 'category')}
										disabled={props.disableIncidentUpdate}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<Dropdown
										id="sub-category"
										label={IncidentDetailsConstants.SubCategory}
										titleText={IncidentDetailsConstants.SubCategory}
										items={subCategoryList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.subcategory}
										onChange={(e) => changeIncidentDataValue(e, 'subcategory')}
										disabled={props.disableIncidentUpdate}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<TextInput id="business-service" labelText={IncidentDetailsConstants.BusinessService} value={incidentDetailsData.business_service} disabled />
								</FormGroup>
							</div>
						</div>
					</div>
					<div className="bx--row">
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<Dropdown
										id="impact"
										label={IncidentDetailsConstants.Impact}
										titleText={IncidentDetailsConstants.Impact}
										items={impactList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.impact}
										onChange={(e) => changeIncidentDataValue(e, 'impact')}
										disabled={props.disableIncidentUpdate}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<Dropdown
										id="urgency"
										label={IncidentDetailsConstants.Urgency}
										titleText={IncidentDetailsConstants.Urgency}
										items={urgencyList}
										itemToString={(item) => (item ? item.label : '')}
										selectedItem={incidentDetailsData.urgency}
										onChange={(e) => changeIncidentDataValue(e, 'urgency')}
										disabled={props.disableIncidentUpdate}
									/>
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
                                    <TextInput id="priority" labelText={IncidentDetailsConstants.Priority} value={priorityBasedOnImpactandUrgency && priorityBasedOnImpactandUrgency.label ? priorityBasedOnImpactandUrgency.label : incidentDetailsData.priority} disabled />
								</FormGroup>
							</div>
						</div>
						<div className="bx--col bx--col-sm-4">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<TextInput id="configuration-item" labelText={IncidentDetailsConstants.ConfigurationItem} value={incidentDetailsData.cmdb_ci} disabled />
								</FormGroup>
							</div>
						</div>
					</div>
                    {props.workspace === workspaces.custom_ops &&
                        <div className="bx--row">
                            {showReasonsToUpgradeDowngrade &&
                                <div className="bx--col bx--col-sm-4">
                                    <div className="disabled-field-text-input">
                                        <FormGroup legendText="">
                                            {UpgradeDowngrade === "Upgrade" &&
                                                <Dropdown
                                                    id={`reasonsToUpgrade`}
                                                    label={IncidentDetailsConstants.ChooseReasons}
                                                    titleText={`${IncidentDetailsConstants.ReasonsToUpgrade}*`}
                                                    items={reasonsToUpgradeList}
                                                    itemToString={(item) => (item ? item.label : '')}
                                                    //selectedItem={incidentDetailsData.reasonsToUpgrade}
                                                    onChange={(e) => changeIncidentDataValue(e, `reasonsToUpgrade`)}
                                                    disabled={props.disableIncidentUpdate}
                                                    invalidText={IncidentDetailsConstants.ReasonsForUpgradeNeeded}
                                                    invalid={upgradeDowngradeError}
                                                />}
                                            {UpgradeDowngrade === "Downgrade" &&
                                                <Dropdown
                                                    id={`reasonsToDowngrade`}
                                                    label={IncidentDetailsConstants.ChooseReasons}
                                                    titleText={`${IncidentDetailsConstants.ReasonsToDowngrade}*`}
                                                    items={reasonsToDowngradeList}
                                                    itemToString={(item) => (item ? item.label : '')}
                                                    //selectedItem={incidentDetailsData.reasonsToDowngrade}
                                                    onChange={(e) => changeIncidentDataValue(e, `reasonsToDowngrade`)}
                                                    disabled={props.disableIncidentUpdate}
                                                    invalidText={IncidentDetailsConstants.ReasonsForDowngradeNeeded}
                                                    invalid={upgradeDowngradeError}
                                                />
                                            }
                                        </FormGroup>
                                    </div>
                                </div>}
                            <div className="bx--col bx--col-sm-4">
                                <div className="disabled-field-text-input">
                                    <FormGroup legendText="">
                                        <Dropdown
                                            id="resolvedBySOC"
                                            label={IncidentDetailsConstants.ResolvedBySOC}
                                            titleText={IncidentDetailsConstants.ResolvedBySOC}
                                            items={resolvedBySOCList}
                                            itemToString={(item) => (item ? item.label : '')}
                                            selectedItem={incidentDetailsData.resolvedBySOC}
                                            onChange={(e) => changeIncidentDataValue(e, 'resolvedBySOC')}
                                            disabled={props.disableIncidentUpdate}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <div className="disabled-field-text-input">
                                    <FormGroup legendText="">
                                        <Dropdown
                                            id="actionTakenBySOC"
                                            label={IncidentDetailsConstants.ActionTakenBySOC}
                                            titleText={IncidentDetailsConstants.ActionTakenBySOC}
                                            items={actionTakenBySOCList}
                                            itemToString={(item) => (item ? item.label : '')}
                                            selectedItem={incidentDetailsData.actionTakenBySOC}
                                            onChange={(e) => changeIncidentDataValue(e, 'actionTakenBySOC')}
                                            disabled={props.disableIncidentUpdate}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
					}
					<div className="bx--row">
						<div className="bx--col bx--col-sm-16">
							<div className="disabled-field-text-input">
								<FormGroup legendText="">
									<TextArea rows={2} labelText={IncidentDetailsConstants.ShortDescription} value={incidentDetailsData.short_description} disabled />
								</FormGroup>
							</div>
						</div>
						{props.Queue &&
							<div className="bx--col bx--col-sm-8">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="queueName" labelText={IncidentDetailsConstants.QueueName} value={incidentDetailsData.u_queueName ? incidentDetailsData.u_queueName : props.QueueName} disabled />
									</FormGroup>
								</div>
							</div>}
					</div>
					<div className="show-more-button">
						<Link href="javascript:void(0)" onClick={toggleFieldsVisibility}>{showMoreFields ? IncidentDetailsConstants.ShowLess : IncidentDetailsConstants.ShowMore}</Link>
					</div>
				</div>
				{showMoreFields &&
					<div className="bx--grid">
						<div className="bx--row">
							<div className="bx--col bx--col-sm-16">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextArea rows={7} labelText={IncidentDetailsConstants.Description} value={incidentDetailsData.description} disabled />
									</FormGroup>
								</div>
							</div>
						</div>
						<div className="bx--row">
							{(props.workspace !== workspaces.sap_ops && props.workspace !== workspaces.custom_ops) &&
								<div className="bx--col bx--col-sm-5">
									<div className="disabled-field-text-input">
										<FormGroup legendText="">
											<TextInput id="app-host" labelText={IncidentDetailsConstants.Apphost} value={incidentDetailsData.u_app_host_machine_name} disabled />
										</FormGroup>
									</div>
								</div>
							}
							<div className="bx--col bx--col-sm-5">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="client" labelText={IncidentDetailsConstants.Client} value={incidentDetailsData.u_client} disabled />
									</FormGroup>
								</div>
							</div>
                            {( props.workspace !== workspaces.custom_ops) &&
							<div className="bx--col bx--col-sm-5">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="technology" labelText={IncidentDetailsConstants.Technology} value={incidentDetailsData.u_technology} disabled />
									</FormGroup>
								</div>
							</div>
                            }
						</div>

						<div className="bx--row">
                        {(props.workspace !== workspaces.custom_ops) &&
							<div className="bx--col bx--col-sm-5">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="job-id" labelText={IncidentDetailsConstants.Jobid} value={incidentDetailsData.u_jobid} disabled />
									</FormGroup>
								</div>
							</div> }
							{(props.workspace !== workspaces.sap_ops && props.workspace !== workspaces.custom_ops) &&
								<div className="bx--col bx--col-sm-5">
									<div className="disabled-field-text-input">
										<FormGroup legendText="">
											<TextInput id="session-number" labelText={IncidentDetailsConstants.SessionNo} value={incidentDetailsData.u_sessionid} disabled />
										</FormGroup>
									</div>
								</div>
							}
                            {(props.workspace !== workspaces.custom_ops) &&
							<div className="bx--col bx--col-sm-5">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="process-id" labelText={IncidentDetailsConstants.ProcessId} value={incidentDetailsData.u_process_id} disabled />
									</FormGroup>
								</div>
							</div>
                            }
						</div>
						<div className="bx--row">
							<div className="bx--col bx--col-sm-4">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="creation-time" labelText={IncidentDetailsConstants.CreationTime} value={incidentDetailsData.creationTime} disabled />
									</FormGroup>
								</div>
							</div>
							{(props.workspace !== workspaces.sap_ops || props.workspace !== workspaces.custom_ops) &&
								<>
									<div className="bx--col bx--col-sm-4">
										<div className="disabled-field-text-input">
											<FormGroup legendText="">
												<TextInput id="start-time" labelText={IncidentDetailsConstants.StartTime} value={incidentDetailsData.startTime} disabled />
											</FormGroup>
										</div>
									</div>
									<div className="bx--col bx--col-sm-4">
										<div className="disabled-field-text-input">
											<FormGroup legendText="">
												<TextInput id="end-time" labelText={IncidentDetailsConstants.EndTime} value={incidentDetailsData.endTime} disabled />
											</FormGroup>
										</div>
									</div>
								</>
							}
							<div className="bx--col bx--col-sm-4">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="updated-time" labelText={IncidentDetailsConstants.UpdatedTime} value={incidentDetailsData.sysTime} disabled />
									</FormGroup>
								</div>
							</div>
						</div>
						<div className="bx--row">
							<div className="bx--col bx--col-sm-8">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="process-name" labelText={(props.workspace !== workspaces.sap_ops || props.workspace !== workspaces.custom_ops) ? IncidentDetailsConstants.ProcessName : IncidentDetailsConstants.ManagedEntityName} value={incidentDetailsData.processName} disabled />
									</FormGroup>
								</div>
							</div>
							<div className="bx--col bx--col-sm-8">
								<div className="disabled-field-text-input">
									<FormGroup legendText="">
										<TextInput id="resource" labelText={IncidentDetailsConstants.Resource} value={incidentDetailsData.u_resource} disabled />
									</FormGroup>
								</div>
							</div>
						</div>
						{(props.workspace !== workspaces.sap_ops && props.workspace !== workspaces.custom_ops) &&
							<>
								<div className="bx--row">
									<div className="bx--col bx--col-sm-8">
										<div className="disabled-field-text-input">
											<FormGroup legendText="">
												<TextInput id="resolution-mode" labelText={IncidentDetailsConstants.Resolutionmode} value={incidentDetailsData.resolutionMode} disabled={props.disableIncidentUpdate} />
											</FormGroup>
										</div>
									</div>
									<div className="bx--col bx--col-sm-8">
										<div className="disabled-field-text-input">
											<FormGroup legendText="">
												<TextInput id="exception-class" labelText={IncidentDetailsConstants.ExceptionClass} value={incidentDetailsData.exceptionClass} disabled={props.disableIncidentUpdate} />
											</FormGroup>
										</div>
									</div>
								</div>
							</>
						}
					</div>
				}
				<IncidentDetailsTab incidentDetailsData={incidentDetailsData} sysId={props.sysId} workspace={props.workspace} client={incidentDetailsData.u_client} franchise={incidentDetailsData.franchise}
					alertType={props.alertType} selectedEntity={incidentDetailsData.selectedEntity}
					aiopsInfo={incidentDetailsData.aiopsInfo} disableIncidentUpdate={props.disableIncidentUpdate}
					updateSomData={updateSomData} showSomUpdateIncidentWarningModal={showSomUpdateIncidentWarningModal} somFieldToBeUpdated={somFieldToBeUpdated}
					closeSomUpdateIncidentWarningModal={closeSomUpdateIncidentWarningModal}
					getIncidentDetails={props.getIncidentDetails} getClassificationStatus={props.getClassificationStatus} Queue={props.Queue} IncidentQueue={props.IncidentQueue}
					AppHostMachineName={props.AppHostMachineName}
				/>
			</div>
		</>
	);
};

export default IncidentDetailsFieldComponent;